import {getUserConfig} from "@utility/utils";

const initialState = {
    list: [],
    total: 0,
    loading: false,
    submitting: false,
    searchParams: {
        club_id: "",
        playerIDs: "",
        groupID: "",
        page: 1,
        count: 30,
        refresh: false,
        ...getUserConfig("tableLimit")
    }
}

const tableLimit = (state = initialState, action) => {
    switch (action.type) {
        case 'TABLE_LIMIT':
            return {
                ...state,
                ...action.payload
            }
        case 'TABLE_LIMIT_RELOAD':
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    refresh: true
                }
            }
        case 'TABLE_LIMIT_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams, ...getUserConfig("tableLimit")
                },
            }
        default:
            return {...state};
    }
}

export default tableLimit
